<template>
  <Popup ref="popup" minHeight="100%" title="钢瓶托管管理">
    <div class="container">
      <van-form @submit="onSubmit">
        <van-field
          name="radio"
          label="托管方式"
          :rules="[{ required: true, message: '选择托管方式' }]"
        >
          <template #input>
            <van-radio-group v-model="custodyFlag" direction="horizontal">
              <van-radio name="1">全部自有</van-radio>
              <van-radio name="2">全部托管</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="custodyUnit"
          name="custodyUnit"
          label="托管单位"
          placeholder="托管单位"
          :rules="[{ required: true, message: '请填写用户名' }]"
          v-if="custodyFlag === '2'"
        />
        <div style="margin: 16px">
          <van-button round block type="primary" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </div>
    <Content :top="240" :bottom="0">
      <ul class="code-list">
        <li v-for="item in selects" :key="item.gsId" class="code-list-item">
          <div class="code-list-item__title">
            {{ item.gsCode }}
          </div>
          <div style="margin-right: 20px">
            {{ item.custodyFlagName
            }}{{ item.custodyFlag === '2' ? `-${item.custodyUnit}` : '' }}
          </div>
        </li>
      </ul>
    </Content>
  </Popup>
</template>

<script>
import { Toast } from 'vant'
import { ref, computed, watch, onMounted } from 'vue'
import { updateCylinderCustodyById } from '@/api/steelCylinder'
export default {
  props: ['checked', 'list'],
  emits: ['update'],
  setup(props, { emit }) {
    console.log(888)
    const custodyFlag = ref('')
    const custodyUnit = ref('')
    const popup = ref(null)
    onMounted(() => {
      watch(
        () => popup.value.show,
        (val) => {
          if (val) {
            custodyFlag.value = ''
            custodyUnit.value = ''
          }
        }
      )
    })
    const selects = computed(() => {
      return props.list.filter((item) => props.checked.includes(item.gsId))
    })
    const onSubmit = async () => {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })

      updateCylinderCustodyById({
        custodyFlag: custodyFlag.value,
        custodyUnit: custodyUnit.value,
        codeArr: props.checked.join(',')
      })
        .then(() => {
          popup.value.hidePopup()
          emit('update')
        })
        .catch(() => {
          Toast('操作失败')
        })
    }
    return {
      popup,
      custodyFlag,
      custodyUnit,
      onSubmit,
      selects
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  font-size: 14px;
  .radio {
    padding: 16px;
  }
}
.code-list {
  padding: 16px 16px 0 16px;
  .code-list-item {
    padding: 10px 16px;
    font-size: 16px;
    background-color: #fff;
    display: flex;
    align-items: center;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
    color: #666;
    &__title {
      flex: 1;
      margin-right: 10px;
    }
  }
}
</style>
